import { isObservable } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Inject, InjectionToken, Injector, NgModule, Type } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { EFFECT } from './create-effects';

const EFFECTS_PROVIDERS = new InjectionToken('EFFECTS_PROVIDERS');
function isEffect(effect: any): any {
	return effect[EFFECT];
}

@NgModule({
	imports: [CommonModule, IonicModule],
})
export class EffectsModule {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(@Inject(EFFECTS_PROVIDERS) providers: Type<any>[], injector: Injector) {
		for (const provider of providers) {
			const currentProvider = injector.get(provider);

			for (const effectFactory of Object.values(currentProvider))
				if (isEffect(effectFactory)) {
					const factory = typeof effectFactory === 'function' && effectFactory();
					if (isObservable(factory)) {
						factory.subscribe();
					}
				}
		}
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - register
	 **-------------------------------------------------------------------------------------
	 */
	static register(providers: Type<any>[]) {
		return {
			ngModule: EffectsModule,
			providers: [
				{
					provide: EFFECTS_PROVIDERS,
					useValue: providers,
				},
			],
		};
	}
}
